import { useState } from "react";
import axios from "axios";
import { toast } from "./use-toast";
import { trackEvent } from "../lib/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EMPTY = { name: "", email: "", phone: "", propertyType: "", message: "", postcode: "", date1: "", date2: "", reviewConsent: false, website: "" };

/**
 * Custom hook for managing quote form state and submission
 */
export function useQuoteForm() {
  const [formData, setFormData] = useState(EMPTY);
  const [photos, setPhotos] = useState([]);
  const [submitted, setSubmitted] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e, quoteData) => {
    e.preventDefault();
    setSubmitting(true);
    const { date1, date2, ...rest } = formData;
    try {
      const res = await axios.post(`${API}/quotes`, {
        ...rest,
        ...quoteData,
        postcode: rest.postcode.trim().toUpperCase(),
        preferredDates: [date1, date2].filter(Boolean),
        photoIds: photos.map((p) => p.id),
      });
      setSubmitted(res.data);
      trackEvent("generate_lead", { service: res.data.selectedService, value: res.data.estimatedPrice, currency: "GBP" });
      setFormData(EMPTY);
      setPhotos([]);
      setTimeout(() => {
        const el = document.getElementById("quote-form");
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: "smooth" });
      }, 50);
    } catch (err) {
      toast({
        title: "Submission Failed",
        description: err?.response?.data?.detail && typeof err.response.data.detail === "string"
          ? err.response.data.detail
          : "Something went wrong. Please try again or call us on 0749 286 5011.",
        variant: "destructive",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return {
    formData,
    photos,
    setPhotos,
    submitted,
    resetSubmitted: () => setSubmitted(null),
    submitting,
    handleFormChange,
    handleSubmit,
  };
}
